import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = comics.filter((c) => c.hot);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门排行
            </h2>
            <p className="text-sm text-foreground-500 mt-2">人气爆棚，万人追更</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors duration-200 whitespace-nowrap"
          >
            完整榜单 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {hotComics.map((comic, index) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all duration-200"
            >
              <div className="relative flex-shrink-0">
                <div className="w-20 h-28 rounded-md overflow-hidden">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}漫画封面`}
                    title={`${comic.title} - 073漫画网热门排行`}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                </div>
                <div className="absolute -top-2 -left-2 w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 text-background-50 text-xs font-bold">
                  {index + 1}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
                <p className="text-xs text-foreground-600 mt-2 line-clamp-2 leading-relaxed">{comic.description}</p>
                <div className="flex items-center gap-3 mt-3">
                  <span className="text-xs text-primary-600 font-medium">
                    <i className="ri-star-fill text-[10px] mr-0.5"></i>{comic.rating}
                  </span>
                  <span className="text-xs text-foreground-400">
                    {(comic.views / 10000).toFixed(0)}万阅读
                  </span>
                  <span className="text-xs text-foreground-400">
                    {comic.chapters}话
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}